import { sentences } from "./sentence"

export const returnSentence = async (sentenceId) => {
  Promise.resolve();
  return sentences[sentenceId];
}
